define([
	"dojo/_base/declare",
	"csi/page",
	"csi/table/Delete"
], function (declare, page, Delete) {

	return declare(Delete, {
		postProcessSuccess: function () {
			this.inherited(arguments);

			const parentNode = this.getParent();
			if (parentNode && !parentNode.Batches.length) {
				page.refreshRootView();
			}
		}
	});
});